// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dJ7W","largestCol":"styles_largestCol__cJjPT","smallestCol":"styles_smallestCol__2-Bo0"};